import ErrorWarning from '../../../Models/ErrorWarningEnum';

export default class ErrorWarningReportModel {

    constructor(public id: string, public courseID: string, public title: string,
        public errorWarning: ErrorWarning, public messageLog: string[], public date: number ) {
    }
}